import OrientButton from './OrientButton';

export default OrientButton;
